export default function floatingHeader(selector) {
    const $floatingHeader = $(selector);

    $(window).bind('scroll', () => {
        if ($(window).scrollTop() > 40) {
            $floatingHeader.addClass('fixedTop');
        } else {
            $floatingHeader.removeClass('fixedTop');
        }
    });
}
